module.exports = __webpack_public_path__ + "static/media/youtub.acd9cc79.svg";